const localesMap = {
  // Missing locales: https://github.com/andyearnshaw/Intl.js/tree/master/locale-data/jsonp
  'en-UK': 'en',
  'no-NO': 'nb-NO',
  'en-QA': 'en',
  'en-AE': 'en',
  'en-SA': 'en'
};
const getIntlLocale = locale => localesMap[locale] || locale;
const isIntlNumberFormatSupported = () => {
  if (!global.Intl) {
    return false;
  }
  try {
    const formatter = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: 'EUR'
    });
    return formatter.formatToParts(10.55).length >= 4;
  } catch (e) {
    return false;
  }
};
const getIntlFileLocale = locale => import(/* webpackChunkName: "[request]" */
`intl/locale-data/jsonp/${locale}`);
export const loadIntlPolyfill = async (locale, logger) => {
  if (isIntlNumberFormatSupported()) {
    return;
  }
  const validLocale = getIntlLocale(locale);
  global.Intl = null;
  await import(/* webpackChunkName: "intl" */
  'intl');
  getIntlFileLocale(validLocale).catch(error => {
    logger.error(error, `OF2_SHELL: Intl file with locale "${validLocale}" download failed`);
    return getIntlFileLocale('en');
  }).then(() => {
    /* Needed to call __disableRegExpRestore() method. See:
     * https://github.com/andyearnshaw/Intl.js/issues/270
     * https://github.com/andyearnshaw/Intl.js#locale-data
     */
    global.Intl.__disableRegExpRestore();
  });
};